module.exports = __webpack_public_path__ + "img/product1.90ba1c06.jpg";